exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled).active-notification[data-v-0a8a95f6]:hover{color:var(--v-secondary-base)!important}.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled).active-notification[data-v-0a8a95f6]:hover{color:var(--v-primary-base)!important}", ""]);

// exports
